import { useTranslation } from 'react-i18next';

const protocolImg = 'http://geel.fp.08wx.cn/images/0f6ab0f65554b793795bd38b4705c50b.jpg';

type LocaleKey = 'zh-CN' | 'en' | 'zh-TW';

const COPY = {
  'zh-CN': {
    badge: 'Staking Protocol',
    title1: '多形态质押协议',
    title2: '灵活策略，最大化收益',
    desc: '支持 PoS 验证质押、AMM 流动性、锁仓质押与 LST 流动性凭证四种模式，用户可根据风险偏好与流动性需求自由选择，平台智能合约确保安全透明。',
    apyLabel: '预期年化',
    lockupLabel: '锁定期',
    coreTag: '质押协议核心',
    coreMeta: '$500M+ TVL · 四种质押模式',
    tags: ['PoS 质押', 'AMM LP', '锁仓挖矿', 'LST 凭证', '自动复投', 'Slash 防护'],
    stakingTypes: [
      { icon: 'ri-coin-line', title: 'PoS 验证者质押', desc: '以太坊 2.0 / Cosmos / Solana 验证节点运营，自动化 Slash 防护，收益每日结算', apy: '3-12%', lockup: '1-7 天', color: '#FF2D78' },
      { icon: 'ri-water-flash-line', title: 'AMM 流动性质押', desc: 'Uniswap V3 / Curve 流动性提供，集中流动性策略管理，Impermanent Loss 对冲', apy: '10-40%', lockup: '灵活赎回', color: '#FF8C42' },
      { icon: 'ri-time-line', title: '锁仓时间质押', desc: '支持 30/90/180/365 天锁仓周期，越长收益越高，支持提前解锁惩罚机制', apy: '8-60%', lockup: '30-365 天', color: '#FF2D78' },
      { icon: 'ri-exchange-dollar-line', title: '流动性质押凭证 LST', desc: '质押即获 stToken 凭证，可继续参与 DeFi，资产流动性不牺牲，双重收益', apy: '5-15%', lockup: '无锁仓', color: '#FF8C42' },
    ],
    coreFeatures: [
      { icon: 'ri-shield-check-line', title: 'Slash 自动防护', desc: '多重验证冗余，自动切换备用节点，Slash 风险归零' },
      { icon: 'ri-pie-chart-line', title: '收益自动复投', desc: '智能合约每日自动复投收益，加速资产增长' },
      { icon: 'ri-lock-line', title: '智能赎回队列', desc: '公平排队机制，大额赎回无需等待，流动性池优先匹配' },
      { icon: 'ri-bar-chart-2-line', title: '实时收益仪表盘', desc: '质押量、APY 趋势、收益历史、节点健康度一目了然' },
    ],
  },
  en: {
    badge: 'Staking Protocol',
    title1: 'Multi-Mode Staking Protocol',
    title2: 'Flexible Strategies, Optimized Yield',
    desc: 'Supports four modes including PoS validator staking, AMM liquidity staking, time-lock staking, and LST receipts. Users can choose based on risk preference and liquidity needs, with smart contracts ensuring security and transparency.',
    apyLabel: 'Estimated APY',
    lockupLabel: 'Lockup',
    coreTag: 'Staking Protocol Core',
    coreMeta: '$500M+ TVL · Four Staking Modes',
    tags: ['PoS Staking', 'AMM LP', 'Lockup Mining', 'LST Receipt', 'Auto Compounding', 'Slash Protection'],
    stakingTypes: [
      { icon: 'ri-coin-line', title: 'PoS Validator Staking', desc: 'Validator operations for Ethereum 2.0 / Cosmos / Solana with automated slash protection and daily settlement.', apy: '3-12%', lockup: '1-7 Days', color: '#FF2D78' },
      { icon: 'ri-water-flash-line', title: 'AMM Liquidity Staking', desc: 'Liquidity provision on Uniswap V3 / Curve with concentrated liquidity strategy management and IL hedging.', apy: '10-40%', lockup: 'Flexible Redemption', color: '#FF8C42' },
      { icon: 'ri-time-line', title: 'Time-Lock Staking', desc: 'Supports 30/90/180/365-day lock periods. Longer lockups provide higher yield with early-unlock penalty options.', apy: '8-60%', lockup: '30-365 Days', color: '#FF2D78' },
      { icon: 'ri-exchange-dollar-line', title: 'Liquid Staking Token (LST)', desc: 'Receive stTokens after staking and continue participating in DeFi without sacrificing liquidity for dual returns.', apy: '5-15%', lockup: 'No Lockup', color: '#FF8C42' },
    ],
    coreFeatures: [
      { icon: 'ri-shield-check-line', title: 'Automated Slash Protection', desc: 'Multi-layer validator redundancy with automatic failover to backup nodes.' },
      { icon: 'ri-pie-chart-line', title: 'Auto Compounding', desc: 'Smart contracts automatically reinvest daily rewards to accelerate asset growth.' },
      { icon: 'ri-lock-line', title: 'Smart Redemption Queue', desc: 'Fair queueing with liquidity-priority matching for large redemptions.' },
      { icon: 'ri-bar-chart-2-line', title: 'Real-Time Yield Dashboard', desc: 'Track staking amount, APY trends, reward history, and node health in one place.' },
    ],
  },
  'zh-TW': {
    badge: 'Staking Protocol',
    title1: '多形態質押協議',
    title2: '靈活策略，最大化收益',
    desc: '支援 PoS 驗證質押、AMM 流動性、鎖倉質押與 LST 流動性憑證四種模式，使用者可依風險偏好與流動性需求自由選擇，平台智慧合約確保安全透明。',
    apyLabel: '預期年化',
    lockupLabel: '鎖定期',
    coreTag: '質押協議核心',
    coreMeta: '$500M+ TVL · 四種質押模式',
    tags: ['PoS 質押', 'AMM LP', '鎖倉挖礦', 'LST 憑證', '自動複投', 'Slash 防護'],
    stakingTypes: [
      { icon: 'ri-coin-line', title: 'PoS 驗證者質押', desc: '以太坊 2.0 / Cosmos / Solana 驗證節點營運，自動化 Slash 防護，收益每日結算', apy: '3-12%', lockup: '1-7 天', color: '#FF2D78' },
      { icon: 'ri-water-flash-line', title: 'AMM 流動性質押', desc: 'Uniswap V3 / Curve 流動性提供，集中流動性策略管理，無常損失對沖', apy: '10-40%', lockup: '彈性贖回', color: '#FF8C42' },
      { icon: 'ri-time-line', title: '鎖倉時間質押', desc: '支援 30/90/180/365 天鎖倉週期，時間越長收益越高，支援提前解鎖懲罰機制', apy: '8-60%', lockup: '30-365 天', color: '#FF2D78' },
      { icon: 'ri-exchange-dollar-line', title: '流動性質押憑證 LST', desc: '質押即獲 stToken 憑證，可繼續參與 DeFi，資產流動性不犧牲，雙重收益', apy: '5-15%', lockup: '無鎖倉', color: '#FF8C42' },
    ],
    coreFeatures: [
      { icon: 'ri-shield-check-line', title: 'Slash 自動防護', desc: '多重驗證冗餘，自動切換備援節點，Slash 風險歸零' },
      { icon: 'ri-pie-chart-line', title: '收益自動複投', desc: '智慧合約每日自動複投收益，加速資產增長' },
      { icon: 'ri-lock-line', title: '智慧贖回佇列', desc: '公平排隊機制，大額贖回無需等待，流動性池優先匹配' },
      { icon: 'ri-bar-chart-2-line', title: '即時收益儀表板', desc: '質押量、APY 趨勢、收益歷史、節點健康度一目了然' },
    ],
  },
};

export default function DefiProtocolSection() {
  const { i18n } = useTranslation();
  const lang = (i18n.resolvedLanguage || i18n.language || 'zh-CN').toLowerCase();
  const locale: LocaleKey = lang.startsWith('zh-tw') || lang.startsWith('zh-hk') ? 'zh-TW' : lang.startsWith('en') ? 'en' : 'zh-CN';
  const copy = COPY[locale];

  return (
    <section id="protocol" className="bg-white py-24">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="flex flex-col lg:flex-row gap-14 xl:gap-20">
          <div className="flex-1 min-w-0">
            <div className="inline-flex items-center gap-2 mb-6 px-3 py-1.5 bg-primary/10 border border-primary/20 rounded-full">
              <i className="ri-coin-line text-primary text-xs" />
              <span className="text-primary text-xs font-medium uppercase tracking-widest">{copy.badge}</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-gray-900 mb-4 leading-tight">
              {copy.title1}
              <br />
              <span className="text-primary">{copy.title2}</span>
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-8">{copy.desc}</p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
              {copy.stakingTypes.map((s, i) => (
                <div key={i} className="bg-light-alt border border-primary/10 rounded-xl p-5 hover:border-primary/25 transition-all duration-200">
                  <div className="flex items-start gap-3 mb-3">
                    <div className="w-8 h-8 flex items-center justify-center rounded-lg flex-shrink-0" style={{ background: `${s.color}12` }}>
                      <i className={`${s.icon} text-sm`} style={{ color: s.color }} />
                    </div>
                    <h4 className="text-gray-800 text-sm font-medium mt-1">{s.title}</h4>
                  </div>
                  <p className="text-gray-500 text-xs leading-relaxed mb-3">{s.desc}</p>
                  <div className="flex gap-3">
                    <div className="flex-1 bg-white rounded-lg px-3 py-2 border border-primary/10">
                      <div className="text-xs text-gray-400 mb-0.5">{copy.apyLabel}</div>
                      <div className="text-sm font-semibold" style={{ color: s.color }}>{s.apy}</div>
                    </div>
                    <div className="flex-1 bg-white rounded-lg px-3 py-2 border border-primary/10">
                      <div className="text-xs text-gray-400 mb-0.5">{copy.lockupLabel}</div>
                      <div className="text-sm font-semibold text-gray-800">{s.lockup}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="grid grid-cols-2 gap-3">
              {copy.coreFeatures.map((f, i) => (
                <div key={i} className="flex items-start gap-3 bg-light-alt border border-primary/10 rounded-xl p-3">
                  <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-primary/10 flex-shrink-0 mt-0.5">
                    <i className={`${f.icon} text-xs text-primary`} />
                  </div>
                  <div>
                    <div className="text-gray-800 text-xs font-medium mb-0.5">{f.title}</div>
                    <div className="text-gray-500 text-xs">{f.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:w-[420px] xl:w-[500px] flex-shrink-0">
            <div className="relative rounded-2xl overflow-hidden border border-primary/15 sticky top-24">
              <div className="w-full h-[340px]">
                <img src={protocolImg} alt="DeFi Protocol" className="w-full h-full object-cover object-top" />
                <div className="absolute inset-0 bg-gradient-to-t from-white/60 via-transparent to-transparent" />
              </div>
              <div className="absolute top-4 left-4 bg-white/95 border border-primary/20 rounded-xl px-4 py-3 backdrop-blur-sm">
                <div className="flex items-center gap-2 mb-1">
                  <i className="ri-coin-line text-primary text-sm" />
                  <span className="text-gray-800 text-xs font-medium">{copy.coreTag}</span>
                </div>
                <div className="text-gray-400 text-xs">{copy.coreMeta}</div>
              </div>
              <div className="absolute bottom-6 left-4 right-4 flex flex-wrap gap-2">
                {copy.tags.map((tag, i) => (
                  <span key={i} className="px-2.5 py-1 bg-white/95 border border-primary/20 text-primary text-xs rounded-lg backdrop-blur-sm">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
